import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'pricerule.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'pricerule.start_zone.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'pricerule.end_zone.name')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'pricerule.pricing.flat_rate')} /></TableCell>
</>

export default React.memo(Row)
